import { CostCentersByLegalEntityDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface Props {
  legalEntityId: number | undefined
  skip?: boolean
}

export const useCostCentersByLegalEntity = ({ legalEntityId, skip }: Props) => {
  const { data, loading } = useQuery(CostCentersByLegalEntityDocument, {
    variables: { legalEntityId: Number(legalEntityId) },
    skip: !legalEntityId || skip,
  })

  return {
    loading,
    canManageCostCenters: data?.finance._policies.costCentersManageCostCenters.can ?? false,
    costCenters: data?.costCenters?.costCentersConnection?.nodes || [],
  }
}
